import type { MutableRefObject } from 'react';
import { POPUP_OPEN_ON_HOVER_CLOSE_DELAY_MS } from './popupHoverConstants';

/** Selector del portal de modal del DS; mientras exista, no se fuerza cierre por hover del popup. */
const MODAL_PORTAL_SELECTOR = '.modal-portal';

export interface PopupHoverCloseSchedulerDeps {
  isOpenRef: MutableRefObject<boolean>;
  overTriggerRef: MutableRefObject<boolean>;
  overPopupRef: MutableRefObject<boolean>;
  closeTimerRef: MutableRefObject<number | null>;
  clearCloseHoverTimer: () => void;
  closePopup: () => void;
}

/**
 * Programa el cierre por hover (tras salir de trigger/panel), respetando modales abiertos
 * (reintenta mientras haya `.modal-portal` en el documento).
 */
export function createPopupHoverCloseScheduler(deps: PopupHoverCloseSchedulerDeps): () => void {
  const schedule = () => {
    deps.clearCloseHoverTimer();
    deps.closeTimerRef.current = window.setTimeout(() => {
      deps.closeTimerRef.current = null;
      if (!deps.isOpenRef.current) {
        return;
      }
      if (document.querySelector(MODAL_PORTAL_SELECTOR)) {
        schedule();
        return;
      }
      if (!deps.overTriggerRef.current && !deps.overPopupRef.current) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!deps.isOpenRef.current) {
              return;
            }
            if (document.querySelector(MODAL_PORTAL_SELECTOR)) {
              schedule();
              return;
            }
            if (!deps.overTriggerRef.current && !deps.overPopupRef.current) {
              deps.closePopup();
            }
          });
        });
      }
    }, POPUP_OPEN_ON_HOVER_CLOSE_DELAY_MS);
  };
  return schedule;
}
